import React from 'react';

import AllInBackground from '../../assets/all-in-background.jpg';
import { usePokerCashGamesWidget } from '../../model';
import { GameType, NavigationTabs } from '../../types';
import GameView from '../GameView/GameView';

import { TXTCLI_Try_a_unique_poker_formatX_bas_ELL } from './AllIn.messages.json';
import styles from './AllIn.scss';

const AllIn: React.FC = () => {
  const { widgetDispatch } = usePokerCashGamesWidget();
  widgetDispatch.setActiveSimpleGameType(GameType.TEMPEST);

  return (
    <div data-testid="all-in" className={styles.allIn}>
      <GameView
        gameVariation={NavigationTabs.TEMPEST}
        hideFormat
        description={TXTCLI_Try_a_unique_poker_formatX_bas_ELL}
        customBackground={AllInBackground}
      />
    </div>
  );
};

export default AllIn;
